import makeStyles from '@mui/styles/makeStyles'

const calcHeight = () => {
  return `${1.1}rem !important`
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  input: {
    marginTop: '24px',

    '& .text > div': {
      height: calcHeight
    },

    '& .text > div > div': {
      height: calcHeight,
      padding: '0 !important'
    },

    '& .text > div > textarea': {
      padding: '0 !important',

      '&::-webkit-scrollbar': {
        width: 8
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.nearWhite
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0
      }
    }
  },
  mentionInputClass: {
    cursor: 'text',
    marginTop: 24,
    '& .text': {
      minHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '0' : keepHeight ? '7rem' : '2rem',
      maxHeight: ({ keepHeight }) => (keepHeight ? '24rem' : '12rem')
    },

    '& .text > div': {
      height: 'auto !important',
      maxHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '4rem' : keepHeight ? '24rem' : '12rem',
      minHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '0' : keepHeight ? '7rem' : '2rem'
    },

    '& .text > div > div': {
      height: 'auto !important',
      maxHeight: ({ keepHeight }) => (keepHeight ? '24rem' : '12rem')
    },

    '& .text textarea': {
      color: ({ isPrivate }) =>
        isPrivate ? theme.palette.primary.main : 'black !important'
    },

    '& #chat-input::placeholder': {
      opacity: 0.5,
      color: ({ isPrivate }) =>
        isPrivate
          ? `${theme.palette.primary.main} !important`
          : '#888888 !important'
    }
  },
  mentionContainerClass: {
    height: 'auto !important'
  }
}))

export default useStyles
